import type { NextStep } from '@klear/schema/document-review-step'

export type ReviewMode = 'processing' | 'creating' | 'blocked' | 'open' | 'filed' | 'denied'

const MODE_BY_STEP: Record<NextStep, ReviewMode> = {
  processing: 'processing',
  creatingRecords: 'creating',
  filed: 'filed',
  filedAutomatically: 'filed',
  dismissed: 'denied',
  filedByLaterRun: 'denied',
  blocked: 'blocked',
  superseded: 'open',
  notProcessed: 'blocked',
  waitingOnYou: 'open',
  waitingOnParent: 'open',
  readyToApprove: 'open'
}

export function reviewMode(step: NextStep): ReviewMode {
  return MODE_BY_STEP[step]
}
